module.exports = __webpack_public_path__ + "img/マツダ.245c4997.png";